import fetchWithAuth from "@/api/secureFetch";
import type { BatchHandle, BatchOrigin, BatchReadiness } from "./types";

async function responseBody(response: Response): Promise<any> {
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        const error = new Error(
            body?.error?.message || body?.error || `Batch request failed (${response.status})`
        ) as Error & { readiness?: BatchReadiness };
        error.readiness = body?.readiness;
        throw error;
    }
    return body;
}

export async function checkBatchReadiness(
    token: string,
    productIds: number[]
): Promise<BatchReadiness> {
    const response = await fetchWithAuth("/api/fde/batch-work-products/readiness", token, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productIds, origin: "chat" })
    });
    return responseBody(response);
}

export async function generateAllWorkProducts(
    token: string,
    productIds: number[],
    origin: BatchOrigin
): Promise<BatchHandle> {
    const response = await fetchWithAuth("/api/fde/batch-work-products/generate", token, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productIds, origin })
    });
    return responseBody(response);
}

export async function getBatchWorkProducts(
    token: string,
    batchId: string
): Promise<BatchHandle> {
    const response = await fetchWithAuth(
        `/api/fde/batch-work-products/${encodeURIComponent(batchId)}`,
        token
    );
    return responseBody(response);
}

export async function listActiveBatchWorkProducts(token: string): Promise<BatchHandle[]> {
    const response = await fetchWithAuth(
        "/api/fde/batch-work-products?status=active",
        token
    );
    const body = await responseBody(response);
    return Array.isArray(body?.batches) ? body.batches : [];
}

export async function cancelBatchWorkProducts(
    token: string,
    batchId: string
): Promise<BatchHandle> {
    const response = await fetchWithAuth(
        `/api/fde/batch-work-products/${encodeURIComponent(batchId)}/cancel`,
        token,
        { method: "POST" }
    );
    return responseBody(response);
}
